/**
 * @param {*} date - possible date value - unknown type
 * @returns {boolean} - whether it is a date object
 */
export const isDate = (date: unknown): date is Date => date instanceof Date;
